import React from 'react';
/**
 * Forces a component to re-render.
 * 
 * @param {React.Component | [boolean, React.Dispatch<React.SetStateAction<boolean>>]} component - The component to re-render. 
 * It can be a class-based component or a functional component using useState.
 * For class-based components, pass the component instance (this).
 * For functional components, pass an array containing the state value and its setter function.
 
* @throws {Error} Throws an error if an invalid component type is provided.
 * 
 * @example
 * // Class-based component usage
 * const myClassComponent = new MyClassComponent();
 * forceComponentUpdate(myClassComponent);
 * 
 * @example
 * // Functional component usage with state
 * const [rerenderFlag, setRerenderFlag] = useState(false);
 * forceComponentUpdate([rerenderFlag, setRerenderFlag]);
 */
function forceComponentUpdate(component) {
  if (component instanceof React.Component) {
    // For class-based components
    component.forceUpdate();
  } else if (Array.isArray(component)) {
    // For functional components using useState
    const [, setState] = component;
    setState((prevState) => !prevState);
  } else {
    throw new Error('Invalid component type. Expected class or functional component.');
  }
}

export default forceComponentUpdate;
